import { hasScreenAccess } from "../../../utils/permissions";
import { isBrowserPhoneChannelEnabled, isCallingEnabled } from "../../../utils/orgFeatures";

export function hasBrowserPhoneScreenAccess() {
  return (
    hasScreenAccess("CC_INBOX", "canView") ||
    hasScreenAccess("CC_TICKETS", "canView") ||
    hasScreenAccess("CC_AGENT_WORKSPACE", "canView") ||
    hasScreenAccess("CC_DASHBOARD", "canView") ||
    hasScreenAccess("CC_CAMPAIGNS", "canView") ||
    hasScreenAccess("CC_SETTINGS", "canView")
  );
}

export function canUseBrowserPhone() {
  if (!isBrowserPhoneChannelEnabled()) {
    return false;
  }
  return hasBrowserPhoneScreenAccess();
}

/** True only when org calling is on and telephony config allows browser phone. */
export function isBrowserPhoneAvailable(config) {
  if (!isBrowserPhoneChannelEnabled()) {
    return false;
  }
  if (!config) {
    return false;
  }
  if (
    config.disabledReason === "CALLING_DISABLED" ||
    config.disabledReason === "WEB_CALLING_DISABLED" ||
    config.disabledReason === "DESKTOP_CALLING_DISABLED" ||
    config.browserPhoneDisableReason === "CALLING_DISABLED" ||
    config.browserPhoneDisableReason === "WEB_CALLING_DISABLED" ||
    config.browserPhoneDisableReason === "DESKTOP_CALLING_DISABLED"
  ) {
    return false;
  }
  return Boolean(config.enableBrowserPhone);
}
